const $ = window.jQuery;

const $DOM = $(document);

const search = {
    init: () => {
        const $btnContainer = $('.button_container');
        const $overlaySerach = $('#overlay-search');
        const $body = $("body");
        $('#toggle-search').on("click", function() {
            $body.toggleClass('lock-scroll');
            $btnContainer.attr('id', 'toggle-search-container');
            $btnContainer.toggleClass('active');
            $overlaySerach.addClass('open');
            $DOM.on('keydown', function(event) {
                if (event.key === "Escape") {
                    $overlaySerach.removeClass('open');
                    $btnContainer.removeClass('active');
                    $body.removeClass('lock-scroll');
                }
            });
        });
        $('#toggle-search-mobile').on("click", function() {
            $overlaySerach.addClass('open');
            $btnContainer.addClass('down');
        })
        $('#search-mobile').on("click", function() {
            $overlaySerach.removeClass('open');
            $btnContainer.removeClass('down');
        })
    }
};
export default search;